export default __webpack_public_path__ + "static/media/flag.244c830a.svg";